import React from 'react'
import { Button, Card } from 'react-bootstrap'
import hooks from '../../../hooks'
import AvailableIOSRedemptions from '../available-ios-redemptions'
import IOSUpdateModal from '../ios-update-modal'

const UpdateModal = ({
    onClose = () => {},
    visible
}) => {
    if (!visible) {
        return null
    }
    return (
        <IOSUpdateModal onClose={onClose} />
    )
}

const IOSManagementCard = () => {
    const { isAdmin } = hooks.useCurrentUser()
    const [isModalVisible, setModalVisible] = React.useState(false)
    
    if (!isAdmin) {
        return null
    }

    return (
        <React.Fragment>
            <Card style={{ width: '18rem' }}>
                <Card.Body>
                    <Card.Title>Apple Management</Card.Title>
                    <Card.Text>
                        IOS Redemptions Available: <AvailableIOSRedemptions />
                    </Card.Text>
                    <Button onClick={() => setModalVisible(true)}>Update</Button>
                </Card.Body>
            </Card>
            <UpdateModal visible={isModalVisible} onClose={() => setModalVisible(false)} />
        </React.Fragment>
    )
}

export default IOSManagementCard
